import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Criterion} from "../../model/criterion";

@Component({
  selector: 'gen-criterion-viewer',
  templateUrl: './criterion-viewer.component.html',
  styleUrls: ['./criterion-viewer.component.scss', '../../trial-curation-styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CriterionViewerComponent {

  @Input() criterion: Criterion;
  @Input() first: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  showAny(): boolean {
    return this.criterion && this.criterion.type == "any" && this.hasConditions();
  }

  showAll(): boolean {
    return this.criterion && this.criterion.type == "all" && this.hasConditions();
  }

  showNone(): boolean {
    return this.criterion && this.criterion.type == "none" && this.hasConditions();
  }

  hasConditions(): boolean {
    return this.criterion && this.criterion.conditions && this.criterion.conditions.length > 0;
  }
}
